export const iconMapper = status => {
    switch (status) {
        case 'ACTIVE':
            return 'check-circle'
        case 'CANCELLED':
            return 'warning'
        case 'FAILED':
        case 'PENDING_CHALLENGE_RESPONSE':
            return 'error'
        case 'USED':
            return 'check-folder'
        case 'EXPIRED':
            return 'alert-folder'
    }
}

export const iconColorMapper = status => {
    switch (status) {
        case 'ACTIVE':
            return 'positive'
        case 'CANCELLED':
        case 'FAILED':
        case 'PENDING_CHALLENGE_RESPONSE':
            return 'negative'
        case 'USED':
        case 'EXPIRED':
        default:
            return 'secondary'
    }
}

export const iconModalMapper = status => {
    switch (status) {
        case 'ACTIVE':
            return 'status-line-success'
        case 'CANCELLED':
            return 'status-line-alert'
        case 'FAILED':
        case 'PENDING_CHALLENGE_RESPONSE':
            return 'status-line-error'
        case 'USED':
            return 'status-line-archived'
        case 'EXPIRED':
        default:
            return 'status-line-expired'
    }
}

export const iconColorMapperModal = status => {
    switch (status) {
        case 'ACTIVE':
            return 'var(--positive)'
        case 'CANCELLED':
        case 'FAILED':
        case 'PENDING_CHALLENGE_RESPONSE':
            return 'var(--negative)'
        case 'USED':
        case 'EXPIRED':
            return 'var(--secondary)'
    }
}
